
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Swiper from 'swiper';
export default {
name: 'Cpts022',
props: {
hasSlot:{
type:Boolean,
default:true
},
gallery: {
type: Array,
default: []
}
},

directives: {
TransferDom
},
components: {
Previewer,
},
mounted() {
new Swiper('.swiper-container', {
slidesPerView: 'auto',
spaceBetween: 20,
observer: true,
observeParents: true,




});
},
methods: {
showViewer () {
this.$refs.previewer.show(0)
},
}
}
